import { compose, lifecycle } from 'recompose';
import { get } from 'lodash';
import { withRouter } from 'react-router';

export default (propPath, urlFunction) => compose(
  withRouter,
  lifecycle({
    componentDidUpdate() {
      if (get(this.props, propPath)) {
        this.props.router.push(urlFunction(this.props));
      }
    },
  })
);



// WEBPACK FOOTER //
// ./src/app/hoc/redirectWhenPropAvailable.js